<template>
  <div>
    <h4 class="up-label pr-1" v-if="label && label.length > 0 && labelIcon.length == 0">
      {{ label }}
    </h4>
    <div :class="`up-icon ${labelIcon}`" v-if="labelIcon.length > 0">
      <span class="up-tooltip">{{ label }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "up-label",
  props: {
    label: {
      type: String,
    },
    labelIcon: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.up-label {
  width: 100%;
  padding: 0px 0px 5px 0px;
  font-weight: 600;
  font-size: 1em;
  line-height: 1.3rem;
  color: black;
}
.up-icon {
  position: relative;
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  line-height: 1.6rem;
  color: black;
}

/* tooltip styles */
.up-tooltip {
  visibility: hidden;
  width: 120px;
  position: absolute;
  text-align: center;
  left: 50%;
  top: -70%;
  transform: translate(-50%, -50%);
  font-size: 1rem;
  background: black;
  color: white !important;
  font-weight: 700;
  border-radius: 8px;
}
div .up-icon:hover .up-tooltip {
  visibility: visible;
}
div .up-icon:hover .up-tooltip::after {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -3px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}
</style>
